// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Split-module__ui-Split--iEAhW {
  display: flex;
  flex-wrap: wrap;
  padding: 36px 44px 60px;
  box-sizing: border-box;
  margin: 0 auto;
}

.Split-module__ui-Split-Top--CY6so {
  flex: 0 0 100%;
  min-width: 0;
}

.Split-module__ui-Split-Side--ozd1z {
  flex: 0 0 350px;
  padding-right: 30px;
  box-sizing: border-box;
  justify-content: flex-start;
  align-self: flex-start;
}

.Split-module__ui-Split-Content--K26yx {
  flex: 1 1 0;
  min-width: 0;
  padding-left: 40px;
  box-sizing: border-box;
}

.Split-module__ui-Split-Side--ozd1z + .Split-module__ui-Split-Content--K26yx {
  border-left: 1px solid #e2ddd5;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Split/Split.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".ui-Split {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 36px 44px 60px;\n  box-sizing: border-box;\n  margin: 0 auto;\n}\n\n.ui-Split-Top {\n  flex: 0 0 100%;\n  min-width: 0;\n}\n\n.ui-Split-Side {\n  flex: 0 0 350px;\n  padding-right: 30px;\n  box-sizing: border-box;\n  justify-content: flex-start;\n  align-self: flex-start;\n}\n\n.ui-Split-Content {\n  flex: 1 1 0;\n  min-width: 0;\n  padding-left: 40px;\n  box-sizing: border-box;\n}\n\n.ui-Split-Side + .ui-Split-Content {\n  border-left: 1px solid #e2ddd5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Split": `Split-module__ui-Split--iEAhW`,
	"ui-Split-Top": `Split-module__ui-Split-Top--CY6so`,
	"ui-Split-Side": `Split-module__ui-Split-Side--ozd1z`,
	"ui-Split-Content": `Split-module__ui-Split-Content--K26yx`
};
export default ___CSS_LOADER_EXPORT___;
